import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { MinaHandelssortimentResultViewModel } from "../mina-handelssortiment-result-view-model";
import { MinaHandelssortimentTexts } from "../mina-handelssortiment.texts";

@Component({
    selector: "rask-mina-handelssortiment-result",
    templateUrl: "./mina-handelssortiment-result.component.html",
    styleUrls: ["./mina-handelssortiment-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        ButtonComponent
    ]
})
export class MinaHandlessortimentResultComponent {
    texts = MinaHandelssortimentTexts.texts;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("addHandelssortiment") addHandelssortiment = new EventEmitter<number>();

    handelssortimentTotalList: MinaHandelssortimentResultViewModel[];
    handelssortimentListaUtvalda: MinaHandelssortimentResultViewModel[];
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("handelssortimentListaUtsokta") set list(val: ISearchHandelssortimentModel[]) {
        if (!val) {
            return;
        }
        this.handelssortimentListaUtvalda = val.map(x => new MinaHandelssortimentResultViewModel(x));
        this.handelssortimentTotalList = this.handelssortimentListaUtvalda;
        this.filterUtvaldaSortiment();
    }

    minaHandelssortiment: MinaHandelssortimentResultViewModel[];
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("minaHandelssortimentList") set minaHsList(val: MinaHandelssortimentResultViewModel[]) {
        if (!val) {
            return;
        }
        this.minaHandelssortiment = val;

        this.handelssortimentListaUtvalda = this.handelssortimentTotalList;
        this.filterUtvaldaSortiment();
    }

    filterUtvaldaSortiment() {
        if (this.handelssortimentListaUtvalda && this.minaHandelssortiment) {
            this.minaHandelssortiment.forEach((item) => {
                if (this.inMinaHandelssortiment(item.id)) {
                    this.handelssortimentListaUtvalda = this.handelssortimentListaUtvalda.filter(x => x.id !== item.id);
                }
            });
        }
    }

    inMinaHandelssortiment(id: number) {
        return this.minaHandelssortiment.find(x => x.id === id);
    }

    addHandelssortimentToMinaHandelssortiment = (id: number) => {
        this.handelssortimentListaUtvalda = this.handelssortimentListaUtvalda.filter(x => x.id !== id);
        this.addHandelssortiment.emit(id);
    };

}
